import type { AnalysisDefinitionStoreState } from './types';

export const selectLoadedVersionId = (state: AnalysisDefinitionStoreState) => state.loadedVersionId;

export const selectCohortProfileId = (state: AnalysisDefinitionStoreState) => state.cohortProfileId;

export const selectSources = (state: AnalysisDefinitionStoreState) => state.sources;

export const selectSourceOrder = (state: AnalysisDefinitionStoreState) => state.sourceOrder;

export const selectHasStagedChanges = (state: AnalysisDefinitionStoreState) =>
  state.hasStagedChanges;

export const selectServerSnapshot = (state: AnalysisDefinitionStoreState) => state.serverSnapshot;
